'use client';
import React from 'react';
import OrderButton from './OrderButton';
import LiveBadge from './LiveBadge';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 pt-16 pb-20 sm:pt-20 sm:pb-24">
      {/* Ambient orbs */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(245,158,11,0.06) 0%, transparent 70%)' }} />
      <div className="absolute top-1/3 left-1/4 w-[300px] h-[300px] rounded-full pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(251,191,36,0.04) 0%, transparent 70%)' }} />
      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center gap-8">

        {/* Live badge */}
        <LiveBadge />

        {/* Product name */}
        <div className="flex flex-col gap-3 sm:gap-4">
          <h1 className="text-4xl sm:text-6xl lg:text-7xl xl:text-8xl font-extrabold tracking-tight leading-none">
            <span className="text-foreground">Luminary</span>
            <span className="text-gradient-gold"> X Pro</span>
          </h1>
          <p className="text-base sm:text-xl lg:text-2xl text-muted-foreground max-w-2xl mx-auto leading-relaxed font-medium">
            A premium digital resource delivered{' '}
            <span className="text-foreground font-semibold">instantly</span>{' '}
            to your Telegram after blockchain payment confirmation.
          </p>
        </div>

        {/* Price display */}
        <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-8">
          <div className="flex flex-col items-center sm:items-start">
            <span className="text-xs font-semibold tracking-widest text-muted-foreground uppercase mb-1">One-time price</span>
            <div className="flex items-baseline gap-3">
              <span className="text-4xl sm:text-6xl font-extrabold text-foreground">$100</span>
              <span className="text-xl font-medium text-muted-foreground">USD</span>
            </div>
          </div>

          <div className="hidden sm:block w-px h-16 bg-border" />

          <div className="flex flex-col items-center sm:items-start">
            <span className="text-xs font-semibold tracking-widest text-muted-foreground uppercase mb-1">Pay in Bitcoin</span>
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0"
                style={{ background: 'linear-gradient(135deg, #f59e0b, #d97706)' }}>
                <span className="text-xs font-black text-black">₿</span>
              </div>
              <span className="font-mono-data text-lg sm:text-xl font-semibold text-primary">≈ 0.00098 BTC</span>
            </div>
            <span className="text-xs text-muted-foreground mt-1">Rate updated at order time</span>
          </div>
        </div>

        {/* CTA */}
        <div className="flex flex-col items-center gap-4 w-full sm:w-auto">
          <OrderButton size="lg" />
          <p className="text-sm text-muted-foreground flex items-center gap-2">
            <svg className="w-4 h-4 text-green-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
            Verified on-chain · No account needed · Instant delivery
          </p>
        </div>

        {/* Trust indicators */}
        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-8 pt-2 sm:pt-4">
          {[
            { icon: '⛓️', label: 'On-chain verified' },
            { icon: '🔒', label: 'No data stored' },
            { icon: '⚡', label: 'Instant delivery' },
            { icon: '₿', label: 'BTC only' },
          ]?.map((item) => (
            <div key={`trust-${item?.label}`} className="flex items-center gap-2 text-sm text-muted-foreground">
              <span>{item?.icon}</span>
              <span>{item?.label}</span>
            </div>
          ))}
        </div>
      </div>
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-pulse-slow">
        <span className="text-xs text-muted-foreground tracking-widest uppercase">Learn more</span>
        <svg className="w-5 h-5 text-muted-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </section>
  );
}